import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { CheckCircle2, Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault(); setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Contraseña actualizada");
      navigate("/login");
    } catch (e2) { setError(formatApiErrorDetail(e2.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-8">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-6"><div className="bg-teal-500/20 text-teal-500 p-2 rounded-full"><CheckCircle2 size={20} /></div><span className="font-display font-bold">Onboarding Follow-Up</span></div>
        <form onSubmit={submit} className="bg-white p-6 rounded-xl border border-slate-200 space-y-4">
          <h2 className="font-display text-lg font-bold text-slate-900">Nueva contraseña</h2>
          <input data-testid="reset-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mínimo 6 caracteres"
            className="w-full px-3 py-2.5 rounded-lg border border-slate-200 focus:border-blue-400 outline-none text-sm" />
          {error && <p className="text-sm text-red-600">{error}</p>}
          <button data-testid="reset-submit" disabled={loading || !token} className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2.5 rounded-lg flex items-center justify-center gap-2 disabled:opacity-60">
            {loading && <Loader2 size={16} className="animate-spin" />} Actualizar
          </button>
          <Link to="/login" className="inline-flex items-center gap-1 text-slate-500 text-sm"><ArrowLeft size={14} /> Volver a ingresar</Link>
        </form>
      </div>
    </div>
  );
}
